import { OverlayContainer } from '@angular/cdk/overlay';
import { Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { filter, forkJoin, map } from 'rxjs';
import { PATHS } from 'src-ironside/app-routing.module';
import { BrandRepository } from 'src-ironside/repositories/brand.repository';
import { CategoryRepository } from 'src-ironside/repositories/category.repository';
import { ComparatorRepository } from 'src-ironside/repositories/comparator.repository';
import { DepartmentRepository } from 'src-ironside/repositories/department.repository';
import { FavoriteRepository } from 'src-ironside/repositories/favorite.repository';
import { NotificationRepository } from 'src-ironside/repositories/notification.repository';
import { DynamicProductParam } from 'src-ironside/repositories/product.repository';
import { SupplierRepository } from 'src-ironside/repositories/supplier.repository';
import { UserRepository } from 'src-ironside/repositories/user.repository';
import { AccueilDataService } from 'src-ironside/services/accueil-data.service';
import { CommonService } from 'src-ironside/services/common.service';
import { PermissionService } from 'src-ironside/services/permission.service';
import { ScreenMediator } from 'src-ironside/services/screen.mediator';
import { SessionStorageService } from 'src-ironside/services/session-storage.service';
import { buildCategoryHierarchyRandom } from 'src-ironside/utils/categories';
import { HttpclientService } from 'src/app/admin/core/services/httpclientService';
import { UserService } from 'src/app/admin/core/services/user.service';
import { KeywordSearchComponent } from 'src/app/shared/components/keyword-search/keyword-search.component';
import { CategoryService } from 'src/app/shared/services/category.service';
import { CustomTranslateService } from 'src/app/shared/services/custom-translate.service';
import { DynamicDocumentService } from 'src/app/shared/services/dynamic-document.service';
import { RestrictService } from 'src/app/shared/services/restrict.service';
import { RouterService } from 'src/app/shared/services/router.service';
import { NotificationComponent } from 'src/app/user/components/notification/notification.component';
import { SousMenu } from 'src/app/user/entites/sous-menu';
import { BurgerComponent } from 'src/app/user/navs/header-user/burger/burger.component';
import { environment } from 'src/environments/environment';

export const SM_WIDTH = 768;

export class HeaderOption {
    ref?: string;
    title?: string; // matToolTip
    icon?: string; // mat-icon
    text?: string; // additional text
    route?: string;
    action?: CallableFunction;
}

export class NavOption {
    id?: string;
    ref: string;
    title: string;
    route?: string;
    count?: number;
    subMenu?: NavOption[];
}

enum Role {
    Partner = '[Extranet - Partenaire]',
    Supplier = '[Extranet - Fournisseur]',
    Partner_Guest = '[Extranet - Partenaire Guest]',
}

@Component({
    selector: 'app-header-user',
    templateUrl: 'header-user.component.html',
    styleUrls: ['header-user.component.css'],
    providers: [
        BrandRepository,
        UserRepository,
        SupplierRepository,
        KeywordSearchComponent,
        CategoryRepository,
        TranslateModule,
        DepartmentRepository,
    ],
})
export class HeaderUserComponent implements OnInit {
    loaded = false;
    headerOptions: HeaderOption[] = [];
    navOptions: NavOption[] = [];
    categories: any[] = [];
    sousMenu: SousMenu[] = [];
    client: string = environment.client;
    defaultIcon = '/assets/images/Pas-dimage-disponible.jpg';
    devisLinesCount: number = 0;
    hoveredNav?: string;

    filters: { [key: string]: any } = {};

    clientLinkedIn: string = environment.linkedin_url;
    currentLangCode = 'en';
    langs = environment.languagesExtranet.map((lang) => {
        return { code: lang.code, text: lang.text };
    });
    roleUser = localStorage.getItem('role');

    routes: any = PATHS;
    checkedHomepage = true;
    checkShowheader = true;
    checkShow: boolean;
    currentUrl: string;
    notificationsPopup: boolean;
    arborescenceCategories: Map<String, any[]> = new Map();
    arborescenceMachines: Map<String, any[]> = new Map();
    arborescenceConsommables: Map<String, any[]> = new Map();

    unreadMsgCount: number = 0;
    comparatorCount: number = 0;
    isRequestedDeletion: boolean = false;
    isMobile: boolean = false;
    showBrandMenu: boolean = false;

    @HostListener('document:click', ['$event']) onDocumentClick(event: any): void {
        if (event.target.className === 'notifications ng-star-inserted') {
            this.notificationsPopup = false;
        }
        if (event.target.className === 'overlayCompara') {
            this.checkShow = false;
            const body = document.querySelector('body');
            this.renderer.removeClass(body, 'overlayCompara');
        }
    }

    @HostListener('window:resize', ['$event']) onWindowResize(event: any) {
        const width = event.target.innerWidth;
        if (width < SM_WIDTH) {
            this.isMobile = true;
            this.showBrandMenu = true;
            this.hoveredNav = 'product';
        } else {
            this.isMobile = false;
        }
    }

    get isMachinesActive(): boolean {
        return (
            window.location.pathname.includes('/catalog') ||
            window.location.pathname.includes('/new-product')
        );
    }

    get isMachinesActiveContact() {
        return (
            window.location.pathname.includes('/contact') ||
            window.location.pathname.includes('/partners')
        );
    }
    get machDepth2() {
        return this.arborescenceMachines.get('depth2');
        // return this.arborescenceMachines.get('depth2')?.sort((a,b) => b.children.length-a.children.length); // Filtrée par nombre de sous-catégorie
    }

    get clientLogo(): string {
        return environment.logo;
    }

    brandSubMenu: any[] = [];

    logoMember: string = '';

    currentUser: any = {};

    extranetRestrictions: { champs: string[]; fonctions: string[]; menu: string[] } = {
        champs: [],
        fonctions: [],
        menu: [],
    };

    currentLang =
        environment.languagesExtranet.find((lang) => lang.code === this.translate.currentLang)
            ?.locale || 'en_GB';

    constructor(
        public router: Router,
        public dialog: MatDialog,
        public categoryService: CategoryService,
        public translateService: CustomTranslateService,
        public routerService: RouterService,
        public dynamicDocumentService: DynamicDocumentService,
        public overlayContainer: OverlayContainer,
        public restrictService: RestrictService,
        public http: HttpclientService,
        private renderer: Renderer2,
        private userService: UserService,
        private brandRepository: BrandRepository,
        private accueilDataService: AccueilDataService,
        private screenMediator: ScreenMediator,
        private notificationRepository: NotificationRepository,
        private comparatorRepository: ComparatorRepository,
        private favoriteRepository: FavoriteRepository,
        private userRepository: UserRepository,
        private supplierRepository: SupplierRepository,
        private sessionStorageService: SessionStorageService,
        private categoryRepository: CategoryRepository,
        private _commonService: CommonService,
        private translate: TranslateService,
        private departmentRepository: DepartmentRepository,
        private permissionService: PermissionService
    ) {
        this.client = environment.client;
        this.translateService.setDefaultLang(localStorage.getItem('lang') ?? 'en');
        this._commonService.getCurrentUserStore().subscribe((res) => {
            this.isRequestedDeletion = res?.isRequestedDeletion ?? false;
        });
    }

    ngOnInit(): void {
        this.translateService.use(this.currentLangCode);
        this.checkRouterShowHide();
        if (
            !window.location.pathname.includes(PATHS.admin) &&
            !window.location.pathname.includes(PATHS.external_download) &&
            !window.location.pathname.includes('retrievepassword')
        ) {
            this.fillNavOptions();
            this.fillHeaderOptions();
            this.loadCategories();
            this.setLang();
            this.loadDepartment();
        }
        this.router.events.subscribe(() => {
            const currentUrl = this.router.url;
            if (currentUrl === '/') {
                this.checkedHomepage = false;
            }
            if (currentUrl === '/login' || currentUrl === '/changer-mot-de-passe') {
                this.checkShowheader = false;
            }
        });

        if (this.checkShowheader) {
            // Use websockets to update the number of unread messages
            // setInterval(() => {
            //     this.notificationRepository.requestCountUnreadNotifications();
            // }, 10000); //10s
            this.notificationRepository.unreadMsgCount$.subscribe((value) => {
                this.unreadMsgCount = value;
            });

            this.comparatorRepository.requestCountComparators().subscribe();
            this.comparatorRepository.comparatorCount$.subscribe((value) => {
                this.comparatorCount = value;
            });

            this.favoriteRepository.getMyFavorites();
            this.getInfoProfile();
        }
        this._commonService.getExtranetRestrictionsStore().subscribe((res) => {
            this.extranetRestrictions = res;
        });
        if (window.innerWidth < SM_WIDTH) {
            this.isMobile = true;
            this.hoveredNav = 'product';
            this.showBrandMenu = true;
        } else {
            this.isMobile = false;
        }
    }

    getInfoProfile(): void {
        this.userRepository
            .getCurrentUser()
            .pipe(
                filter((res) => !!res?.email),
                map((res) => {
                    this.currentUser = res.obj;
                    this._commonService.setCurrentUserStore(res.obj);
                    const linkToLegalEntityId =
                        this.currentUser?.linkToLegalEntity?.documentId ??
                        this.currentUser?.linkToLegalEntity[0]?.documentId ??
                        '';

                    return linkToLegalEntityId as string;
                })
            )
            .subscribe((linkToLegalEntityId) => {
                this.supplierRepository.getDetailSupplierById(linkToLegalEntityId).subscribe({
                    next: (res) => {
                        if (
                            res?.logo &&
                            Array.isArray(res.logo) &&
                            res.logo.length > 0 &&
                            res.logo[0]?.url
                        ) {
                            this.logoMember = res.logo[0].url;
                        }
                    },
                    error: (error) => {},
                });
            });
    }

    loadBrands() {
        /* return new Promise<any>((resolve, reject) => {
            this.brandRepository.find().subscribe({
                next: (res) => {
                    const result = res.map((brand) => ({
                        id:brand.id,
                        ref: brand.value,
                        title: brand.title,
                        route: brand.value,
                    }))
                    resolve(result);
                    this._commonService.setBrandStore(res)
                },
                error: () => {
                    reject();
                },
            });
        }); */
        return new Promise<any>((resolve, reject) => {
            const body = {
                filters: [
                    {
                        fieldName: 'statusProduct.parameterId',
                        conditions: [
                            {
                                type: 'EQUALS',
                                value: '65e58fd64a6e8e68b5c667e5',
                            },
                        ],
                    },
                ],
                locales: ['fr_FR'],
                groupBy: 'brand',
            };
            const bodySupplier: DynamicProductParam = {
                filters: [],
                fields: [],
                locales: [this.currentLang],
            };
            forkJoin([
                this.brandRepository.find(),
                this.dynamicDocumentService.getAggregateCountDynamic('dynamic_product', body),
                this.dynamicDocumentService.getDataParameterCountByDocumentName(
                    bodySupplier,
                    'suppliers'
                ),
            ]).subscribe({
                next: ([brands, countByBrand, countBySupplier]) => {
                    const result = brands.map((brand) => {
                        const countItem = countByBrand?.data?.find(
                            (c: any) => c?.value === brand?.value
                        );

                        const sortSupplier = countBySupplier.sort((a: any, b: any) =>
                            a?.supplier?.companyName.localeCompare(b?.supplier?.companyName)
                        );

                        this._commonService.setBrandQuantityStore(countByBrand?.data);
                        this._commonService.setSupplierQuantityStore(sortSupplier);
                        return {
                            id: brand.id,
                            ref: brand.value,
                            title: brand.title,
                            route: brand.value,
                            count: countItem?.count || 0,
                        };
                    });

                    this._commonService.setBrandStore(brands);
                    resolve(result);
                },
                error: () => {
                    reject();
                },
            });
        });
    }

    loadDepartment() {
        const body: DynamicProductParam = {
            filters: [],
            fields: [],
            locales: [this.currentLang],
        };
        return new Promise<any>((resolve, reject) => {
            this.dynamicDocumentService
                .getDataParameterCountByDocumentName(body, 'departments')
                .pipe(
                    map((res) => {
                        return res
                            .map((el: any) => ({
                                count: el.count,
                                id: el.id,
                                title: el?.department?.mapLocalLibelle,
                            }))
                            .sort((a: any, b: any) =>
                                a?.title?.[this.currentLang].localeCompare(
                                    b?.title?.[this.currentLang]
                                )
                            );
                    })
                )
                .subscribe({
                    next: (res) => {
                        const result = res;
                        resolve(result);
                        this._commonService.setDepartmentStore(res);
                    },
                    error: () => {
                        reject();
                    },
                });
        });
    }

    checkRouterShowHide(): void {
        const access = localStorage.getItem('access');

        if (
            (access && access.includes('admin')) ||
            (!access && window.location.pathname.includes(PATHS.login))
        ) {
            this.checkShowheader = false;
        } else if (access && !access.includes('admin')) {
            this.checkShowheader = true;
        }
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.currentUrl = event.urlAfterRedirects;
                if (this.currentUrl === '/home' || this.currentUrl === '/') {
                    this.checkedHomepage = false;
                } else {
                    this.checkedHomepage = true;
                }
            }
        });
    }

    getDepth3(id: string): any[] {
        return this.categories?.filter((el) => el.attachmentCategory?.[0]?.documentId == id);
    }

    setLang() {
        const langCurrent = localStorage.getItem('lang');
        if (langCurrent) {
            this.currentLangCode = langCurrent;
            this.translateService.use(langCurrent);
        } else {
            this.currentLangCode = this.translateService.currentLang;
            localStorage.setItem('lang', this.currentLangCode);
        }
    }

    getRoute(cat: any) {
        let trNameCategory = this.translateService
            .getMultilingualFieldValue(cat.nameCategory)
            .replace(' ', '_');
        return `/${PATHS.catalogues_en}/${this.hoveredNav}/${trNameCategory}`;
    }

    onTranslate(code: string) {
        this.currentLangCode = code;
        this.translate.use(code);
        this.translateService.use(code);
        localStorage.setItem('lang', code);
    }

    loadCategories() {
        this.categoryRepository.findAllCategoryLevel(3).subscribe((res: any) => {
            if (!res || res.length === 0) {
                return;
            }
            this._commonService.setFlatCategories(res);
            const result = buildCategoryHierarchyRandom(res);
            this._commonService.setCategories(result);
        });
    }

    sortCategories() {
        this.arborescenceMachines.set('depth1', []);
        this.arborescenceMachines.set('depth2', []);
        this.arborescenceMachines.set('depth3', []);
        this.arborescenceMachines.set('depth4', []);
        this.arborescenceConsommables.set('depth1', []);
        this.arborescenceConsommables.set('depth2', []);
        this.arborescenceConsommables.set('depth3', []);
        this.arborescenceConsommables.set('depth4', []);

        let mach = this.categories.find((el) => el.codeCategory == '1');
        let cons = this.categories.find((el) => el.codeCategory == '3');

        if (mach) {
            this.arborescenceMachines.set('depth1', [mach]);
            this.setMachinesChildren(mach);
        }

        if (cons) {
            this.arborescenceConsommables.set('depth1', [cons]);
            this.setConsommablesChildren(cons);
        }
    }

    setMachinesChildren(categorie: any) {
        if (categorie.subcategories) {
            for (let i = 0; i < categorie.subcategories.length; i++) {
                let childx = categorie.subcategories?.[i];
                let child = this.categories.find((el) => el.id == childx.documentId);
                if (child) {
                    let val = this.arborescenceMachines.get('depth' + child.categoryLevel);
                    this.arborescenceMachines.set(
                        'depth' + child.categoryLevel,
                        val ? val.concat([child]) : []
                    );

                    if (child.subcategories) this.setMachinesChildren(child);
                }
            }
        }
    }

    getTranslatedRoute(route?: string) {
        return this.routerService.getTranslatedRoute(route);
    }

    setConsommablesChildren(categorie: any) {
        if (categorie.subcategories) {
            for (let i = 0; i < categorie.subcategories.length - 1; i++) {
                let childx = categorie.subcategories?.[i];
                let child = this.categories.find((el) => el.id == childx.documentId);
                if (child) {
                    let val = this.arborescenceConsommables.get('depth' + child.categoryLevel);
                    this.arborescenceConsommables.set(
                        'depth' + child.categoryLevel,
                        val ? val.concat([child]) : []
                    );

                    if (child.subcategories) this.setConsommablesChildren(child);
                }
            }
        }
    }

    openSubMenu(nav: NavOption) {
        const width = window.innerWidth;
        if (width > SM_WIDTH) {
            if (nav.subMenu) {
                this.addClassOverlay();
            }
            this.hoveredNav = nav.subMenu ? nav.ref : undefined;
        }
    }

    fillHeaderOptions() {
        if (this.headerOptions.length == 0)
            this.http
                .get<NavOption[]>(`assets/mock-apis/extranet-header-${environment.client}.json`)
                .pipe(
                    map((head) => {
                        this.headerOptions = head;
                    })
                )
                .subscribe();
    }

    fillNavOptions() {
        if (this.navOptions.length == 0)
            this.userService.retriveUserRole().then((role) => {
                this.http
                    .get<{ partner: NavOption[]; supplier: NavOption[] }>(
                        `assets/mock-apis/extranet-menu-${environment.client}.json`
                    )
                    .pipe(
                        map(async (data) => {
                            if (
                                !this.permissionService.isPermissionFonction('export-photos-hd') &&
                                !this.permissionService.isPermissionFonction(
                                    'export-informations-commerciales'
                                ) &&
                                !this.permissionService.isPermissionFonction(
                                    'export-ressource-videos'
                                )
                            ) {
                                data = {
                                    ...data,
                                    partner: data?.partner.filter(
                                        (item: any) => item.ref !== 'downloads'
                                    ),
                                };
                            }
                            let nav: NavOption[] = [];
                            /* if (
                                this.roleUser === Role.Partner ||
                                this.roleUser === Role.Partner_Guest
                            ) {
                                nav = data.partner;
                            }
                            if (this.roleUser === Role.Supplier) {
                                nav = data.supplier;
                            } */
                            if (this.roleUser === Role.Supplier) {
                                nav = data.supplier;
                            } else {
                                nav = data.partner;
                            }
                            if (
                                Array.isArray(nav) &&
                                nav.length > 1 &&
                                nav[1].subMenu &&
                                nav[1].subMenu[2]
                            ) {
                                nav[1].subMenu[2].subMenu = await this.loadBrands();
                            }

                            this.loaded = true;
                            if (this.userService.role?.extranetRestrictions?.menu?.length > 0) {
                                const filterNavTree = (navItems: NavOption[]): NavOption[] => {
                                    return navItems
                                        .filter((n: NavOption) =>
                                            this.userService.role?.extranetRestrictions?.menu.includes(
                                                n.ref
                                            )
                                        )
                                        .map((nav: NavOption) => ({
                                            ...nav,
                                            subMenu: nav.subMenu
                                                ? nav.subMenu.filter((sub) =>
                                                      this.userService.role?.extranetRestrictions?.menu.includes(
                                                          sub.ref
                                                      )
                                                  )
                                                : undefined,
                                        }));
                                };

                                this.navOptions = filterNavTree(nav);
                            } else {
                                this.navOptions = nav;
                            }

                            this.permissionService.permissionsLoadedSubject.next(true);
                        })
                    )
                    .subscribe();
            });
    }

    notifications() {
        this.dialog.open(NotificationComponent, {
            width: '300px',
            height: '100vh',
            position: {
                right: '0',
                top: '0',
            },
        });
    }

    openBurger() {
        this.dialog.open(BurgerComponent, { data: this.navOptions });
    }

    addClassOverlay(): void {
        const body = document.querySelector('body');
        if (this.hoveredNav == 'product' || this.hoveredNav == 'contact') {
            this.renderer.addClass(body, 'overlay');
        } else {
            this.renderer.removeClass(body, 'overlay');
        }
    }
    delClassOverlay(): void {
        if (!this.isMobile) {
            this.hoveredNav = undefined;
            const body = document.querySelector('body');
            this.renderer.removeClass(body, 'overlay');
        }
    }

    checkShowPopup(): void {
        this.checkShow = !this.checkShow;
        if (this.checkShow) {
            const body = document.querySelector('body');
            this.renderer.addClass(body, 'overlayCompara');
        } else {
            const body = document.querySelector('body');
            this.renderer.removeClass(body, 'overlayCompara');
        }
    }

    notificationsShowPopup(): void {
        this.notificationsPopup = !this.notificationsPopup;
        this.checkShow = false;
        const body = document.querySelector('body');
        this.renderer.removeClass(body, 'overlayCompara');
    }

    isShowNav: boolean = false;
    onToggleNav(d2?: any) {
        this.isShowNav = !this.isShowNav;
        if (!this.isShowNav && !this.isMobile) {
            this.hoveredNav = undefined;
        }
    }

    onRedirecProductList(router: any) {
        if (router === '/new-product') {
            const dataFilter: any = {
                isNewProduct: true,
            };
            this.accueilDataService.filterData = {};
            this.sessionStorageService.setFilters(dataFilter);
            this.router.navigate([router]);
        } else if (router === 'brands' && this.isMobile) {
            this.hoveredNav = this.hoveredNav === 'product' ? undefined : 'product';
            this.showBrandMenu = !this.showBrandMenu;
        } else {
            this.router.navigate([router]);
        }
        this.sessionStorageService.removeItem('selectedChildren');
    }

    menuClick(nav: NavOption) {
        const width = window.innerWidth;
        const body = document.querySelector('body');
        this.renderer.removeClass(body, 'overlay');

        if (this.isMobile && (nav.ref === 'product' || nav.ref === 'contact')) {
            if (this.hoveredNav === nav.ref) {
                this.hoveredNav = undefined;
            } else {
                this.hoveredNav = nav.ref;
            }
        } else {
            if (width > SM_WIDTH) {
                this.hoveredNav = undefined;
            } else {
                // toggle sub-menu
                if (this.hoveredNav) {
                    this.hoveredNav = undefined;
                } else {
                    //
                    this.hoveredNav = nav.subMenu ? nav.ref : undefined;
                }
                if (!nav.subMenu) {
                    this.isShowNav = false;
                }
            }
            this.sessionStorageService.removeItem('selectedChildren');
        }
        // for pc

        if (nav.ref === 'showroom') {
            window.open(
                'https://www.lookin3d.fr/visite-virtuelle/showroom-ironside/fullscreen/',
                '_blank'
            );
        }
    }

    goToSearchPage(brand: NavOption) {
        if (brand.route) {
            this.screenMediator.toMarqueDetail(brand.route, brand.title);
            this.sessionStorageService.setFilters({ brand: [brand.id] });
            this.accueilDataService.filterData = {};
        }
        this.sessionStorageService.removeItem('selectedChildren');
    }

    onRedirecHome() {
        location.href = '#';
    }

    isPermissionMenu(role: any) {
        return this.extranetRestrictions?.menu?.includes(role);
    }

    getFilteredNavOptions(): NavOption[] {
        return this.navOptions.filter((nav) => {
            if (nav.ref === 'contact') {
                return this.isPermissionMenu('ironside') || this.isPermissionMenu('partners');
            }
            return true;
        });
    }
}
